import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse } from "./types";

// 绑定相关API
export const bindApi = {
  /**
   * 获取服务器列表
   * @returns Promise<ApiResponse>
   */
  getServerList: (game_id: string | number): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.BIND,
      API_CONFIG.ACTIONS.SERVER_LIST,
      {
        game_id,
      }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 获取角色列表
   * @returns Promise<ApiResponse>
   */
  getRoleList: (
    game_id: string | number,
    server_id: string | number
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.BIND,
      API_CONFIG.ACTIONS.ROLE_LIST,
      {
        game_id,
        server_id,
      }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 绑定角色
   * @returns Promise<ApiResponse>
   */
  bindRole: (
    game_id: string | number,
    server_id: string | number,
    role_id: string | number,
    server_name: string,
    role_name: string
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.BIND,
      API_CONFIG.ACTIONS.BIND_ROLE,
      {
        game_id,
        server_id,
        role_id,
        server_name,
        role_name,
      }
    );
    return post<ApiResponse>(url);
  },
};
